/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'goal-fields.goal-followers.add-followers-title': 'Добавить подписчиков',
  'goal-fields.goal-followers.title': 'Подписчики',
  'goal-fields.goal-links.add-parent-goal-title': 'Добавьте родительскую цель',
  'goal-fields.goal-links.edit-parent-goal-title': 'Редактировать родительскую цель',
  'goal-fields.goal-links.unlink-parent-goal-title': 'Отвязать родительскую цель',
  'goal-fields.goal-metrics.automatic-metric-title': 'По подцелям',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.remove-label': 'Удалить',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.settings-label': 'Настройки',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.show-more': 'Показать еще',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.update-value-label': 'Обновить значение',
  'goal-fields.goal-metrics.manual-metrics-popup-content.start-value-label': 'Начальное значение:',
  'goal-fields.goal-metrics.manual-metrics-popup-content.target-value-label': 'Целевое значение:',
  'goal-fields.goal-metrics.metrics-popup.external-metric-description':
    'Прогресс автоматически заполняется через {compass}. Целевой показатель можно отредактировать только в {compass}.',
  'goal-fields.goal-metrics.no-metrics-instructions': 'Чтобы изменить это поле, перейдите на полную страницу цели',
  'goal-fields.goal-metrics.no-metrics-title': 'Нет показателей',
  'goal-fields.goal-metrics.open-in-new-window-label': 'Открыть в новом окне',
  'goal-fields.goal-metrics.percentage-metric-completion-percentage.description': 'достигнутый прогресс',
  'goal-fields.goal-metrics.rollup-metric-title-no-sub-goals': 'Нет подцелей со связанными показателями',
  'goal-fields.goal-metrics.title': 'Прогресс',
  'goal-fields.goal-owner.title': 'Владелец',
  'goal-fields.goal-start-date.add-start-date-title': 'Добавить дату начала',
  'goal-fields.goal-start-date.cancel-button': 'Сохранить',
  'goal-fields.goal-start-date.creation-date': 'Цель создана {creationDate}',
  'goal-fields.goal-start-date.edit-start-date-label': 'Изменить дату начала для цели',
  'goal-fields.goal-start-date.enter-start-date-title': 'Введите дату начала',
  'goal-fields.goal-start-date.open-calendar-label': 'Открыть календарь',
  'goal-fields.goal-start-date.title': 'Дата начала',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-in-progress': 'В работе',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-more-button': 'Другие статусы',
  'goal-fields.goal-status-picker.goal-status-okr-current-status': 'Каков текущий статус?',
  'goal-fields.goal-status-picker.goal-status-okr-help-content':
    'Применяете цели и ключевые результаты (OKR)? <link>Узнайте, как использовать цели для отслеживания OKR</link>',
  'goal-fields.goal-status-picker.goal-status-okr-help-info-icon-label': 'Ссылка на справку',
  'goal-fields.goal-status.archived': 'Архивированные',
  'goal-fields.goal-status.at-risk': 'В зоне риска',
  'goal-fields.goal-status.cancelled': 'Отменено',
  'goal-fields.goal-status.completed': 'Выполнено 🎉',
  'goal-fields.goal-status.off-track': 'С отставанием от графика',
  'goal-fields.goal-status.on-track': 'По графику',
  'goal-fields.goal-status.paused': 'Приостановлено',
  'goal-fields.goal-status.pending': 'В ожидании',
  'goal-fields.goal-status.title': 'Статус',
  'goal-fields.goal-sub-goals.add-sub-goals-title': 'Добавить подцели',
  'goal-fields.goal-sub-goals.unlink-sub-goal-tooltip': 'Отвязать подцель',
  'goal-fields.goal-tags.add-tags-title': 'Добавить теги',
  'goal-fields.goal-tags.title': 'Теги',
  'goal-fields.goal-target-date.picker-placeholder': 'В ожидании',
  'goal-fields.goal-target-date.title': 'Целевая дата',
  'goal-fields.goal-type.goal': 'Цель',
  'goal-fields.goal-type.key-result': 'Ключевой результат',
  'goal-fields.goal-type.objective': 'Задача',
  'goal-fields.goal-type.title': 'Тип',
  'goal-fields.parent-goal.title': 'Родительская цель',
  'goal-fields.sub-goals.title': 'Подцели',
  'goal-fields.teams.add-teams-title': 'Добавить команды',
  'goal-fields.teams.follow-team': 'Отслеживать команду',
  'goal-fields.teams.remove-team': 'Удалить команду',
  'goal-fields.teams.search-team-placeholder': 'Поиск команды',
  'goal-fields.teams.show-more': 'Показать еще',
  'goal-fields.teams.title': 'Команды',
  'goal-fields.teams.verified-team-label': 'Проверенная команда',
  'goal-fields.teams.view-profile': 'Просмотреть профиль',
  'goal-fields.use-goal-flags.generic-error-description': 'Произошла ошибка. Повторите попытку через несколько минут.',
  'goal-fields.use-goal-flags.generic-error-title': 'Произошла ошибка',
  'goal-fields.use-goal-flags.goal-owner-change-error-header': 'Не удалось изменить владельца цели',
  'goal-fields.use-goal-flags.goal-tags-add-failure-title': 'Не удалось добавить тег',
  'goal-fields.use-goal-flags.goal-tags-create-failure-title': 'Не удалось создать тег',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-description':
    'Введено слишком длинное имя тега. Введите имя тега длиной не более 255 символов.',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-title': 'Не удалось создать тег',
  'goal-fields.use-goal-flags.goal-tags-remove-failure-title': 'Не удалось удалить тег',
  'goal-fields.use-goal-flags.goal-teams-add-failure-title': 'Ошибка при добавлении команды. Повторите попытку',
  'goal-fields.use-goal-flags.goal-teams-remove-failure-title': 'Ошибка при удалении команды. Повторите попытку',
  'goal-fields.use-goal-flags.parent-goal-change-error-header': 'Не удалось изменить родительскую цель',
  'goal-fields.use-goal-flags.start-date-change-error-header': 'Не удалось изменить дату начала',
  'goal-fields.use-goal-flags.target-date-change-error-header': 'Не удалось изменить целевую дату',
  'townsquare.goal-fields.tag': 'Удалить тег',
  'townsquare.goal-fields.tooltip-usage-count':
    '{usageCount, plural, one {Используется в {usageCount,number} месте} few {Используется в {usageCount,number} местах} many {Используется в {usageCount,number} местах} other {Используется в {usageCount,number} места}}',
};
